let cadessAnalysis = {};

/**
 * @description Necessary to be able to access values in redux state.
  Props could not be combined with "value" from Field in redux form
 * @param analysis
 */
export const setCadessAnalysisForValidation = (analysis) => {
  cadessAnalysis = analysis;
};

/**
 * @description Compares values and returns a message if the values differ
 * @param formValue
 * @param cadessValue
 * @param additionalText
 * @returns {*}
 */
const cadessValidation = (formValue, cadessValue, additionalText) => (
  formValue && cadessValue !== null
  && cadessValue && formValue !== cadessValue
    ? `Warning: CADESS suggests ${additionalText}. Please check.` : undefined);


export const cadessTumorTypeValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.tumourType,
    cadessAnalysis.tumourType,
  )
);

export const cadessGleasonPrimaryValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.gleasonPrimary,
    `a Gleason primary grade of ${cadessAnalysis.gleasonPrimary}`,
  )
);

export const cadessGleasonRemainingValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.gleasonRemaining,
    `a Gleason secondary grade of ${cadessAnalysis.gleasonRemaining}`,
  )
);

export const cadessISUPGradeGroupValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.ISUPGradeGroup,
    `ISUP Grade Group ${cadessAnalysis.ISUPGradeGroup}`,
  )
);

export const cadessNbPosCoresValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.nbPosCores,
    `${cadessAnalysis.nbPosCores} positive core(s)`,
  )
);

export const cadessCarcinomaLengthValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.carcinomaLength,
    `a length of ${cadessAnalysis.carcinomaLength} mm of tissue involved`,
  )
);

export const cadessCarcinomaExtentValidation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.carcinomaExtent,
    `${cadessAnalysis.carcinomaExtent}% of tissue involved by carcinoma`,
  )
);

export const cadessPercentageG45Validation = (value) => (
  cadessValidation(
    value,
    cadessAnalysis.percent_4_5,
    `${cadessAnalysis.percent_4_5}% of Gleason Pattern 4/5`,
  )
);
